const origin = document.location.origin;

const meta = {
    alt: 'Medicare Your Way with PlanEnroll',
    image: `${origin}/images/og.jpg`,
    largeImage: `${origin}/images/twitter.jpg`
};

export default meta;
